<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="userSearch.name"
    @on-confirm="advsearch"
    @on-cancel="hide()"
    :okText="$t('Search')"
    :closeText="$t('Close')"
    maxWidth="60%"
  >
    <div v-for="item in conditionItems" :key="item.uuid">
      <SearchCriteriaCondition
        :ref="`searchCriteriaConditionKey${item.uuid}`"
        :fieldList="fieldList"
        :conditionItem="item"
        :origin="5"
        v-if="item.isLogicalOperator == false"
      />
    </div>
  </base-modal>
</template>

<script>
import SearchCriteriaCondition from '@/components/search/SearchCriteriaCondition.vue';
import SearchService from '@/services/SearchService';
import ConditionItem from '@/ecm/models/search/ConditionItem';
import UserSearch from '@/ecm/models/UserSearch';
import SearchUtils from '@/components/search/utilsSearch/UtilsSearch.js';
import SearchType from '@/ecm/variables/SearchType';
import StandardFieldCode from '@/ecm/variables/StandardFieldCode';

export default {
    name: 'ParamSearchModal',
    components: {
        SearchCriteriaCondition,
    },
    data() {
        return {
            modal: {
                key: 'paramSearchModal',
            },
            userSearch: new UserSearch(),
            open: false,
            conditionItems: [],
            fieldList: [],
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
    },
    methods: {
        async getFields() {
            var standardFields = this.$store.getters['account/searchStandardFields'];
            if (this.userSearch.contentTypeIDs != '') {
                var fields = await SearchService.getAdvSearchFields(
                    this.userSearch.contentTypeIDs
                );
                return [...fields, ...standardFields];
            } else {
                return standardFields;
            }
        },
        advsearch() {
            var condition = '';

            const fulltextEmptyItems = this.conditionItems.filter(item =>
                item.fieldCode == StandardFieldCode.Fulltext &&
                (!item.fieldDisplayValue || item.fieldDisplayValue.trim() === '' || item.fieldDisplayValue.length < 2)
            );

            if (fulltextEmptyItems.length > 0) {
                this.$nextTick(() => {
                    fulltextEmptyItems.forEach(item => {
                        try {
                            const childRef = this.$refs[`searchCriteriaConditionKey${item.uuid}`];
                            if (childRef && childRef[0]) {
                                childRef[0].$v.conditionItem.fieldDisplayValue.$touch();
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    });
                });

                return;
            }
            if (this.conditionItems.length > 0) {
                condition = this.conditionItems
                    .map((item) => item.conditionStr())
                    .join(';');
            }
            if (condition == '') {
                return;
            }
            var pattern = {
                contentTypeIDs: this.userSearch.contentTypeIDs.join(','),
                searchPattern: condition,
                groupPattern: this.userSearch.groupStr,
                sortPattern: this.userSearch.sortStr,
                searchAllVersions: this.userSearch.searchAllVersions,
            };
            this.modalInstance.progress(true);
            var route = '/search/';
            route += `${SearchType.AdvancedSearch}/${encodeURIComponent(
                JSON.stringify(pattern)
            )}`;
            this.$router.push(route);
            this.modalInstance.progress(false);
            this.hide();
        },
        setConditionItemDisplayValues(conditionItem) {
            var field = this.fieldList.find((x) => x.Code == conditionItem.fieldCode);
            if (field) {
                conditionItem.fieldTitle = field.Title;
            }
            var searchOperator = this.$store.getters['account/searchOperators'].find(
                (x) => x.Code == conditionItem.searchOperatorCode
            );
            if (searchOperator) {
                conditionItem.searchOperatorTitle = searchOperator.Title;
            }
            const context = this;
            if (!conditionItem.fieldDisplayValue) {
                conditionItem.fieldDisplayValue = SearchUtils.GetDisplayValueFromFieldValue(
                    conditionItem.fieldValue, context
                );
            } else {
                conditionItem.fieldDisplayValue = SearchUtils.GetDisplayValueFromFieldValue(
                    conditionItem.fieldDisplayValue, context
                );
            }
        },
        async edit(dto) {
            this.userSearch = new UserSearch(dto);
            this.fieldList = await this.getFields();
            this.conditionItems = [];
            this.userSearch.conditionStr.split(';').forEach((condition) => {
                var conditionItem = new ConditionItem(condition);
                this.setConditionItemDisplayValues(conditionItem);
                this.conditionItems.push(conditionItem);
            });
            this.show();
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>
